<mat-card class="mat-card-element-force-relative">
    <h3 mat-dialog-title class="title">Document Link</h3>
    <mat-dialog-content class="mat-dialog-content-spacing-vertical">
        <strong>Invite others to access your document by copying and pasting this link.</strong>
        <br />
        <mat-label class="mat-label-position-absolute">
            For security purposes, a First To File login is required to access the document.
        </mat-label>
    </mat-dialog-content>
    <form [formGroup]="shareLinkForm" class="shareLink-form mat-form-field-input-description">
        <mat-form-field>
            <input matInput formControlName="shareLinkInput" autofocus onfocus="this.select()"/>
        </mat-form-field>
    </form>
    <mat-dialog-actions align="center">
        <button mat-button mat-raised-button (click)="dialogRef.close()" color="primary">OK</button>
    </mat-dialog-actions>
</mat-card>
  